<template>
  <div class="pl-aside-page">
    <div class="pl-aside-page-content">
      <slot name="main"></slot>
    </div>
    <aside class="pl-aside-page-aside" id="page-aside">
      <slot name="aside"></slot>
    </aside>
  </div>
</template>
<script>
export default {
  name: "AsidePage"
};
</script>
